import ConfigCmsApi from '../configs/ConfigCmsApi';
import Cookies from 'js-cookie';

const options = () => ({ headers: { Authorization: Cookies.get('adminToken') } });
const path = id => `/partner-videos/${encodeURIComponent(id)}`;

export default {
  list: params => ConfigCmsApi.get('/partner-videos', { ...options(), params, timeout: 30000 }),
  get: id => ConfigCmsApi.get(path(id), options()),
  action: (id, action, data) => ConfigCmsApi.post(`${path(id)}/${action}`, data, options()),
  mediaUrl: id => `${String(ConfigCmsApi.defaults.baseURL).replace(/\/$/, '')}${path(id)}/media`,
};
